<template>
  <div class="input-with-units">
    <div class="input-wrapper" :style="{width: minWidth+'px'}">
      <input ref="input" v-model="nonValidatedValue" :style="{paddingRight: (minWidth-baseWidth)+'px'}":class="status" @focus="onFocus"/>
      <span class="unit-span" ref="unitSpan">{{unit}}</span>
    </div>
    <div class="warn" v-if="status==='invalid'">{{$t("out_of_range")}}: [{{this.min}},{{this.max}}]</div>
  </div>
</template>

<script>
const INPUT_MIN_WIDTH = 70
export default {
  props:['value','unit','min','max','round'],
  model:{
    prop: 'value',
    event: 'change',
  },
  data () {
    return {
      status: 'valid',
      internalValue: null,
      minWidth: INPUT_MIN_WIDTH
    }
  },
  methods:{
    onFocus () {
      // if(this.unit) this.$refs.input.setSelectionRange(0,this.$refs.input.value.length-this.unit.length-1)
      this.$refs.input.setSelectionRange(0,this.$refs.input.value.length)
    },
    validate(val){
      return !isNaN(val) && (this.min===undefined || val>=this.min) && (this.max===undefined || val<=this.max)
    },
    setPrecission(val){
      // no acababa de funcionar... ya veremos si hace falta...
      return val
      // if(!this.round) return val
      // else {
      //   let currentDigits = val.countDecimals()
      //   let digits = -Math.log10(this.round)
      //   return currentDigits>digits ? val.toFixed(digits) : val
      // }
    }
  },
  mounted(){
    let unitLength = this.$refs.unitSpan ? this.$refs.unitSpan.getBoundingClientRect().width : 0//this.unit ? this.unit.length : 0
    this.minWidth = (unitLength + INPUT_MIN_WIDTH)
  },
  computed:{
    baseWidth(){
      return INPUT_MIN_WIDTH - 10
    },
    nonValidatedValue:{
      get(){
        return this.internalValue
      },
      set(val){
        this.internalValue = val
        this.validatedValue = val
      }
    },
    validatedValue: {
      get(){
        if(this.validate(this.value)) this.status='valid'
        else  this.status='invalid'
        
        return this.value //this.unit ? this.value + ' ' +this.unit : this.value
      },
      set(v){
        let val = isNaN(+v)?v:+v
        if(this.validate(val)) {
          this.status='valid'
          this.$emit('change',this.setPrecission(val))
        } else {
          this.status='invalid'
        }   
      }
    },
  },
  watch:{
    value: {
      handler() {
        this.internalValue = this.validatedValue
      },
      immediate: true
    }
  }
}
</script>

<style lang="stylus" scoped>
.input-with-units
  position relative
  display flex
  flex-direction column
  .input-wrapper
    position relative
    input 
      width: 100%;
      &.invalid
        background-color #fee
    .unit-span
      // @xavi very hardcoded, pero algo "asi"
      position: absolute;
      right: 0;
      line-height: 32px;
      font-size: 12px;
      justify-content: center;
      margin-right: 6px;
      padding-left: 6px;
      opacity: 0.4;
      border-left: solid 1px rgba(0,0,0,0.2);
  .warn
    font-size 10px
    color #f44
    position absolute
    bottom -20px
    white-space: pre
</style>